"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _react = require("react");
var _TextField = _interopRequireDefault(require("./TextField.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CurrencyInput = /*#__PURE__*/(0, _react.memo)(props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
    InputProps: {
      startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
        children: "\xA3",
        position: "start",
        disableTypography: true
      })
    },
    isPrice: true,
    step: "0.01",
    placeholder: "0.00",
    type: "number",
    ...props
  });
});
var _default = exports.default = CurrencyInput;